import api from "../Api";
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// إضافة صور لمنتج (formData مع حقول images[][image], images[][title_ar], images[][title_en])
export const addProductImages = async (productId, formData, params = {}) => {
  if (!productId) throw new Error("product id is required to add images.");

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(`/admin/add-product-images/${productId}`, formData, {
      headers,
      params: mergedParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding product images:", error);
    // surface validation errors if present
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// تحديث صور المنتج (يمكن أن يتضمن images[0][id], images[0][image], images[0][title_ar], images[0][title_en], ...)
export const updateProductImages = async (formData, params = {}) => {
  if (!formData) throw new Error("formData is required to update product images.");

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post("/admin/update-product-images", formData, {
      headers,
      params: mergedParams,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating product images:", error);
    // surface validation errors if present
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// حذف صور منتجات بواسطة مصفوفة image_ids (JSON body)
export const deleteProductImages = async (imageIds = [], params = {}) => {
  if (!Array.isArray(imageIds) || imageIds.length === 0) {
    throw new Error("imageIds array is required to delete images.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      "/admin/delete-product-images",
      { image_ids: imageIds },
      { headers, params: mergedParams }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting product images:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// إضافة مقاسات للمنتج (JSON body مع حقل sizes)
export const addProductSizes = async (productId, sizes = [], params = {}) => {
  if (!productId) throw new Error("product id is required to add sizes.");
  if (!Array.isArray(sizes) || sizes.length === 0) {
    throw new Error("sizes array is required to add product sizes.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/add-product-sizes/${productId}`,
      { sizes },
      { headers, params: mergedParams }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding product sizes:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// تحديث مقاسات المنتج (تقبل مصفوفة sizes، كل عنصر يحتوي على id لتحديثه)
export const updateProductSizes = async (sizes = [], params = {}) => {
  if (!Array.isArray(sizes) || sizes.length === 0) {
    throw new Error("sizes array is required to update product sizes.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      "/admin/update-product-sizes",
      { sizes },
      { headers, params: mergedParams }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating product sizes:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// حذف مقاسات (Product Sizes) بالـ IDs
export const deleteProductSizes = async (sizeIds, params = {}) => {
  // تقبل: [36, 37] أو رقم واحد 36
  const normalizedIds = Array.isArray(sizeIds) ? sizeIds : [sizeIds];

  if (!normalizedIds.length) {
    throw new Error("size_ids is required (array of ids).");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/delete-product-sizes`,
      { size_ids: normalizedIds },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting product sizes:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// إضافة عملات/أسعار لمنتج (JSON body مع حقل currencies)
export const addProductCurrencies = async (productId, currencies = [], params = {}) => {
  if (!productId) throw new Error("product id is required to add currencies.");
  if (!Array.isArray(currencies) || currencies.length === 0) {
    throw new Error("currencies array is required to add product currencies.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/add-product-currencies/${productId}`,
      { currencies },
      { headers, params: mergedParams }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding product currencies:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};
// تحديث عملات المنتج (prices per country)
export const updateProductCurrencies = async (currencies, params = {}) => {
  if (!Array.isArray(currencies) || !currencies.length) {
    throw new Error("currencies is required and must be a non-empty array.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-product-currencies`,
      { currencies },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating product currencies:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// حذف عملات المنتج بالـ IDs
export const deleteProductCurrencies = async (currencyIds, params = {}) => {
  // تقبل رقم واحد أو Array
  const normalizedIds = Array.isArray(currencyIds)
    ? currencyIds
    : [currencyIds];

  if (!normalizedIds.length) {
    throw new Error("currency_ids is required (array of ids).");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/delete-product-currencies`,
      { currency_ids: normalizedIds },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting product currencies:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// إضافة Features لمنتج
export const addProductFeatures = async (productId, features = [], params = {}) => {
  if (!productId) throw new Error("product id is required to add features.");
  if (!Array.isArray(features) || features.length === 0) {
    throw new Error("features array is required to add product features.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/add-product-features/${productId}`,
      { features },
      { headers, params: mergedParams }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding product features:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};
// تحديث Features (لازم كل feature يحتوي id)
export const updateProductFeatures = async (features, params = {}) => {
  if (!Array.isArray(features) || !features.length) {
    throw new Error("features is required and must be a non-empty array.");
  }

  // تحقق سريع إن كل عنصر فيه id
  const hasMissingId = features.some((f) => !f || typeof f.id === "undefined" || f.id === null);
  if (hasMissingId) {
    throw new Error("Each feature must include a valid id to update.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-product-features`,
      { features },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error updating product features:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};

// حذف مميزات المنتج بالـ IDs
export const deleteProductFeatures = async (featureIds, params = {}) => {
  const normalizedIds = Array.isArray(featureIds) ? featureIds : [featureIds];

  if (!normalizedIds.length) {
    throw new Error("feature_ids is required (array of ids).");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/delete-product-features`,
      { feature_ids: normalizedIds },
      { headers, params: mergedParams }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting product features:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// إضافة ألوان لمنتج
export const addProductColors = async (productId, colors, params = {}) => {
  if (!productId) {
    throw new Error("productId is required.");
  }

  if (!Array.isArray(colors) || !colors.length) {
    throw new Error("colors is required and must be a non-empty array.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/add-product-colors/${productId}`,
      { colors },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error adding product colors:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};
// تحديث ألوان المنتج (تقبل مصفوفة colors، كل عنصر يجب أن يحتوي id لتحديثه)
export const updateProductColors = async (colors = [], params = {}) => {
  if (!Array.isArray(colors) || !colors.length) {
    throw new Error("colors is required and must be a non-empty array.");
  }

  // تحقق سريع إن كل عنصر فيه id
  const hasMissingId = colors.some((c) => !c || typeof c.id === "undefined" || c.id === null);
  if (hasMissingId) {
    throw new Error("Each color must include a valid id to update.");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/update-product-colors`,
      { colors },
      {
        headers,
        params: mergedParams,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating product colors:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// حذف ألوان المنتج بالـ IDs
export const deleteProductColors = async (colorIds, params = {}) => {
  // تقبل رقم واحد أو Array
  const normalizedIds = Array.isArray(colorIds) ? colorIds : [colorIds];

  if (!normalizedIds.length) {
    throw new Error("color_ids is required (array of ids).");
  }

  const headers = {
    "Content-Type": "application/json",
    ...getAuthHeaders(),
  };

  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.post(
      `/admin/delete-product-colors`,
      { color_ids: normalizedIds },
      {
        headers,
        params: mergedParams,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting product colors:", error);

    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);

      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }

      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }

    throw error;
  }
};